import React from 'react';
import { cn } from '@ideoz/ui';

export type PillOptionGroupProps<T extends string> = {
  options: Array<{ value: T; label: string }>;
  value?: T;
  onChange: (value: T) => void;
  className?: string;
};

export function PillOptionGroup<T extends string>({
  options,
  value,
  onChange,
  className,
}: PillOptionGroupProps<T>): JSX.Element {
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {options.map((opt) => {
        const selected = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            aria-pressed={selected}
            className={cn(
              'rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors',
              selected
                ? 'border-blue-300 bg-blue-50 text-blue-500 shadow-sm dark:border-blue-500/40 dark:bg-blue-500/10 dark:text-blue-300'
                : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:border-gray-600 dark:hover:bg-gray-700/40'
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default PillOptionGroup;
